









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { AdminCouponRoute } from '@/modules/coupon/routes/admin-coupon.route'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'

@Component({
  components: {
    ActionShowButton,
    BaseButton
  }
})
export default class AdminCouponIndexPageActions extends Vue {
  constructor(
    private routes: AdminCouponRoute
  ) {
    super()
  }

  @Prop({ required: true }) couponId: number

  private get couponEditPageLink() {
    return this.routes.edit(this.couponId)
  }
}
